export default "__VITE_ASSET__BOqgyxpj__"